import React, { Component } from 'react'

class CTA extends Component {
  render() {
    return (
      <div className="section top-cta darker-bg">
        <div className="container">
          <div className="columns cta-wrapper">
            <div className="column is-8 cta-content">
              <h1 className="item-title" style={{ paddingBottom: "0" }}>Secure Your Software.</h1>
              <h1 className="item-title">Protect Your Business.</h1>
              <a href="/contact" className="cta-button">
                <button className="btn-golden item-button">Talk to Us</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CTA;
